import type { AxiosPromise } from "axios";
import { route } from "../../shim/jsbridge";

import type { Config, Errors } from "./@types";
import { AxiosApiWrapper } from "../../services/api/AxiosApiWrapper";

class Api extends AxiosApiWrapper {
  integrationsConfigOverview = (): AxiosPromise<Config.Overview> =>
    this.get(route("api_integrations_config_overview"));

  updateIntegrationsFileTypes = (
    data: Partial<Config.OverviewFiletypes["values"]>
  ): AxiosPromise<Errors.UpdateFiletypes> =>
    this.post(route("api_integrations_filetypes"), data);

  /**
   *  Cisco Secure Malware Analytics (Threat Grid) config
   */
  getCiscoSecureMalwareAnalyticsConfig =
    (): AxiosPromise<Config.CiscoSmaSettings> =>
      this.get(route("api_cisco_secure_malware_analytics_config"));

  setCiscoSecureMalwareAnalyticsConfig = (
    data: Partial<Config.CiscoSmaSettings>
  ) => this.post(route("api_cisco_secure_malware_analytics_config"), data);

  updateCiscoSecureMalwareAnalyticsConfig = (
    data: Partial<Config.CiscoSmaSettings>
  ) => this.patch(route("api_cisco_secure_malware_analytics_config"), data);

  validateCiscoSecureMalwareAnalyticsApi = (
    api_url: Config.CiscoSmaSettings["api_url"],
    api_key: Config.CiscoSmaSettings["api_key"],
    api_key_set: Config.CiscoSmaSettings["api_key_set"]
  ) =>
    this.post(route("api_cisco_secure_malware_analytics_validate_api"), {
      api_url,
      api_key,
      api_key_set
    });

  testCiscoSecureMalwareAnalyticsConnection =
    (): AxiosPromise<Config.TestConnectionResponse> =>
      this.get(route("api_test_cisco_secure_malware_analytics_connection"));

  validateCiscoSecureMalwareAnalyticsWeb = (
    web_url: Config.CiscoSmaSettings["web_url"]
  ) =>
    this.post(route("api_cisco_secure_malware_analytics_validate_web"), {
      web_url
    });

  fetchCiscoSecureMalwareAnalyticsProfiles =
    (): AxiosPromise<Config.FetchProfilesResponse> =>
      this.get(
        route("api_cisco_secure_malware_analytics_fetch_available_profiles")
      );
}

export default new Api();
